import React from 'react';
import NewsCard from '../components/NewsCard';
import { articles } from '../data/mockData';

const Resources = () => {
  return (
    <div className="container-custom py-8 min-h-screen">
      <div className="max-w-3xl mb-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Educational Resources</h1>
        <p className="text-gray-600 text-lg">
          In-depth guides, regulatory updates, and expert analysis on moringa safety, usage, and benefits. 
          Our editorial team ensures all content is evidence-based and reviewed by health professionals.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {articles.map(article => (
          <NewsCard key={article.id} article={article} />
        ))}
        {/* Repeating for mockup fullness */}
        {articles.map(article => (
          <NewsCard key={`rep-${article.id}`} article={{...article, id: `rep-${article.id}`, title: `Archive: ${article.title}`}} />
        ))}
      </div>
    </div>
  );
};

export default Resources;